import {
  Box,
  Button,
  DialogBackdrop,
  DialogContent,
  DialogPositioner,
  DialogRoot,
  Heading,
  Image,
  Text,
} from "@chakra-ui/react";
import photo from "./images/compete-profile-photo.jpg";
import { useNavigate } from "react-router-dom";

interface CompleteProfileReminderDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const CompleteProfileReminderDialog = ({
  open,
  onOpenChange,
}: CompleteProfileReminderDialogProps) => {
  const navigate = useNavigate();
  return (
    <DialogRoot open={open} onOpenChange={(d) => onOpenChange(d.open)}>
      <DialogBackdrop />
      <DialogPositioner>
        <DialogContent
          maxW="25rem"
          w="calc(100% - 2rem)"
          mx="auto"
          my="2rem"
          maxH="calc(100dvh - 4rem)"
          borderRadius="xl"
          bg="bg.canvas"
          display="flex"
          flexDirection="column"
          overflow="hidden"
        >
          <Box flex="1" minH="0" overflowY="auto" padding="1rem">
            <Box position="relative" paddingBottom="1rem">
              <Image src={photo} width="100%" marginBottom="2rem" alt="" />
              <Heading as="h3" textStyle="headingSm" textAlign="center">
                You're Registered! 🎉
              </Heading>
              <Heading as="h3" textStyle="headingSm" textAlign="center">
                Don't Miss Out on Matches — Fill Out Your Profile!
              </Heading>
              <Text fontSize="1rem" marginY="2rem" textAlign="center">
                Your future matches can't find you if they can't see you -
                complete your profile before the event!
              </Text>
            </Box>
          </Box>

          <Box position="sticky" bottom={0} background="white" padding="1rem">
            <Button
              variant="solid"
              width="100%"
              onClick={() => navigate("/settings/profile")}
            >
              Complete Profile
            </Button>
          </Box>
        </DialogContent>
      </DialogPositioner>
    </DialogRoot>
  );
};
